import { render, staticRenderFns } from "./check-groups.vue?vue&type=template&id=b9362a42"
import script from "./check-groups.vue?vue&type=script&lang=js"
export * from "./check-groups.vue?vue&type=script&lang=js"
import style0 from "./check-groups.vue?vue&type=style&index=0&id=b9362a42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports